module.exports = __webpack_public_path__ + "img/0Q3A6947_8_P_L_Wood_MockedUp.8a07d697.jpg";